import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQ_ITEMS } from "../data";
import { Reveal } from "./Reveal";

export default function Faq() {
    return (
        <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-stone-50">
            <div className="max-w-4xl mx-auto px-4 md:px-8">
                <Reveal>
                    <p className="text-xs font-bold uppercase tracking-[0.3em] text-emerald-800 mb-4">Dúvidas frequentes</p>
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-stone-900 leading-tight">
                        Antes de fazer as malas.
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
                        {FAQ_ITEMS.map((item, i) => (
                            <AccordionItem key={i} value={`item-${i}`} className="border-stone-300">
                                <AccordionTrigger
                                    data-testid={`faq-question-${i}`}
                                    className="text-left text-base md:text-lg font-bold text-stone-900 hover:text-emerald-800 hover:no-underline py-6"
                                >
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-stone-600 text-base leading-relaxed pb-6" data-testid={`faq-answer-${i}`}>
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
